import styled from 'styled-components';

export const WidgetContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 2rem;
  min-width: 12rem;

  p {
    width: 100%;
    min-height: 100%;
  }
`;

export const TextContent = styled.div`
  display: flex;
  width: 100%;
  flex-direction: column;
  gap: 0.5rem;
`;
